import { post, get } from "../utils/apiUtils";

const API_URL_MCP = `/api/v1/mms_persistence/mcp_server`;
const API_URL_FETCH_MCP = `/api/v1/mms_common/fetch_mcp_tools`;


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const fetchMCPServer = async () => {
    try {
        const defaultPayload = { "mcp_servers_names" : [] };
        const responce = await post(API_URL_FETCH_MCP, defaultPayload);
        return responce;
    } catch (error) {
        console.error('Error while fetching the mcp server.', error);
        throw error;
    }
}

